import { SC_Input } from '../input/SC_Input';
import { Sol50 } from '../mountsys/Sol50';

export class HGroup {
	public x: number;
	public y: number;
	/**
	 * width of the group<br>
	 * Attention: this field is set and used in the panel array editor only
	 */
	public width: number;
	public height: number;
	public nModWith: number;
	public iCnt: number;
	public mixed: boolean = false;
	constructor(aobj?: any) {
		if (aobj) {
			if (aobj.panelCount) {
				const obj = aobj;
				let panelWidth = (SC_Input.nModWidth / 10);
				let panelHeight = (SC_Input.nModHeight / 10);
				let w, h;
				if (obj.portrait) {
					w = panelWidth
					h = panelHeight;
				} else {
					w = panelHeight;
					h = panelWidth;
				}
				this.x = obj.x;
				this.y = obj.y;
				this.width = w * obj.panelCount + Sol50.nHorizontalAbstand * (obj.panelCount - 1);
				this.height = h;
				this.nModWith = w;
				this.iCnt = obj.panelCount;
				this.mixed = obj.mixed;

			} else if (aobj && aobj.length > 0) {
				const obj = aobj[0];
				this.x = obj.x;
				this.y = obj.y;
				this.width = obj.width * aobj.length + Sol50.nHorizontalAbstand * (aobj.length - 1);
				this.height = obj.height;
				this.nModWith = obj.width;
				this.iCnt = aobj.length;
				aobj.forEach((item: any) => {
					if (!this.mixed) this.mixed = item.width != aobj[0].width;
				});
			}
		}
	}
}